/** Merged Chinese Near Me copy (flagship wave 1 + wave 2). */
import { NEAR_ZH_COPY, type NearLocaleCopy } from "./zh-copy";
import { NEAR_ZH2_COPY } from "./zh-copy-2";
import type { NearZhAnyKey } from "./zh-keys";

export const NEAR_ZH_ALL_COPY: Record<NearZhAnyKey, NearLocaleCopy> = {
  ...NEAR_ZH_COPY,
  ...NEAR_ZH2_COPY,
};
